import request from "../utils/request";


export function upload(files) {
    let formData = new FormData()
    files.forEach(item => formData.append('files', item))
    return request({
        url: '/api/custom/picture/upload',
        method: 'post',
        data: formData
    })
}

export function deletePicture(pictureNo) {
    return request({
        url: '/api/custom/picture/delete',
        method: 'delete',
        params: {picture_no: pictureNo}
    })
}

export function addOrderPicture(orderId, pictureId) {
    return request({
        url: '/api/custom/picture/order/add',
        method: 'post',
        data: {
            order_id: orderId,
            picture_id: pictureId
        }
    })
}

export function deleteOrderPicture(orderId,pictureId) {
    return request({
        url:'/api/custom/picture/order/delete',
        method:'delete',
        params:{
            order_id: orderId,
            picture_id: pictureId
        }
    })
}